import React, { useEffect, useState, useContext, useMemo } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import kategori from "../kategori.json";
import Cookies from "js-cookie";
import ProductPagination from "./ProductPagination";

const AllProductCard = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("");
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { product, setProduct, fetchStatus, setFetchStatus } = contextState;
  const { renderDataProduct } = contextFunctions;

  const itemsPerPage = 10;
  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // const currentItems = props.items.slice(startIndex, endIndex);

  const handleDetail = (event) => {
    const id = event.target.getAttribute("data-item");
    navigate(`/products/${id}`);
    setFetchStatus(true);
  };
  const setConfig = () => {
    if (Cookies.get("token") === undefined) {
      return null;
    } else return Cookies.get("token");
  };
  const config = {
    headers: { "x-access-token": setConfig() },
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get("https://productspec.cyclic.app/product", config)
      .then((res) => {
        const tempArr = res.data.map((el) => {
          return el;
        });
        setProduct(tempArr);
        setLoading(false);
        return tempArr;
      })
      .catch((e) => alert(e.message));
  }, []);

  const handleKategori = (event) => {
    setCurrentPage(0);
    setSelectedCategory(event.target.value);
  };

  const resetKategori = () => {
    setSelectedCategory("");
  };

  const renderText = (str) => {
    return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };

  let filtered = useMemo(() => {
    if (product == undefined) {
      return [];
    } else {
      if (selectedCategory === "") {
        return product;
      } else if (selectedCategory !== null) {
        return product.filter((el) => el.jenis_produk == selectedCategory);
      }
    }
  }, [selectedCategory, product, fetchStatus, setFetchStatus, currentPage]);

  if (loading) {
    return <p className="loading"></p>;
  }
  return (
    <div>
      <div className="row">
        <div className="dropdown ">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedCategory === ""
              ? "Lihat berdasarkan kategori"
              : `${renderText(selectedCategory)}`}
          </button>
          <ul className="dropdown-menu">
            {selectedCategory !== "" && (
              <li>
                <button
                  className="dropdown-item btn fw-bold"
                  onClick={resetKategori}
                  type="button"
                >
                  Reset Kategori
                </button>
              </li>
            )}
            {kategori.map((el) => (
              <li>
                <button
                  className="dropdown-item"
                  onClick={handleKategori}
                  value={el}
                  type="button"
                >
                  {renderText(el)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <ProductPagination
          arrProducts={filtered}
          selectedCategory={selectedCategory}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default AllProductCard;
